import {useEffect, useState} from 'react';
import useTranslation from 'next-translate/useTranslation';

import ALERT_TYPES from './alertTypes';

type SnackbarState = {
  text: string;
  alertType: 'success' | 'error';
};

export const useContactUsAlert = () => {
  const {t} = useTranslation('common');
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    text: '',
    alertType: ALERT_TYPES.SUCCESS,
  });
  const [isAlertVisible, setIsAlertVisible] = useState(false);

  const showAlert = (alertType: string) => {
    if (alertType === ALERT_TYPES.SUCCESS) {
      setSnackbar({
        text: t('components.ContactUs.modal.confirmation'),
        alertType: ALERT_TYPES.SUCCESS,
      });
    } else {
      setSnackbar({
        text: t('components.ContactUs.modal.failure'),
        alertType: ALERT_TYPES.ERROR,
      });
    }
    setIsAlertVisible(true);
  };

  useEffect(() => {
    if (!isAlertVisible) return undefined;

    const timer = setTimeout(() => setIsAlertVisible(false), 5000);
    return () => {
      clearTimeout(timer);
    };
  }, [isAlertVisible]);

  const hideAlert = () => setIsAlertVisible(false);

  return {
    snackbar,
    isAlertVisible,
    showAlert,
    hideAlert,
  };
};
